import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const TrafficIcon: FC<Props> = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-labelledby="titleId"
      {...props}
     aria-label="traffic icon">
      {/* <title>traffic icon</title> */}
      <path
        d="M14.5 2.31494C18.014 3.21939 20.7805 5.98588 21.685 9.4999"
        stroke={props.fill || "currentColor" || "#3064C0"}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M22 12C22 13.9778 21.4135 15.9112 20.3147 17.5557C19.2159 19.2002 17.6541 20.4819 15.8268 21.2388C13.9996 21.9957 11.9889 22.1937 10.0491 21.8079C8.10929 21.422 6.32746 20.4696 4.92893 19.0711C4.59299 18.7351 4.28279 18.3771 4 18M2.19215 13.9509C1.80629 12.0111 2.00433 10.0004 2.7612 8.17317C3.51808 6.3459 4.79981 4.78412 6.4443 3.6853C8.08879 2.58649 10.0222 2 12 2"
        stroke={props.fill || "currentColor" || "#3064C0"}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default TrafficIcon;
